import storeModule from './store'

let config

const validateOptions = (options) => {
  if (!options.store) throw new Error('Please provide a Vuex store')
  if (!options.EventBus) throw new Error('Please provide an EventBus')

  return options
}

const registerStoreModule = () => {
  config.store.registerModule('activitySummary', storeModule)
}

export default {
  install (Vue, options) {
    config = validateOptions(options)
    Vue.prototype.$_activitySummary_config = config
    registerStoreModule()
  }
}



// WEBPACK FOOTER //
// ./~/vue-components/activity-summary/index.js